import React, { useState, useEffect } from 'react';
import { Fab, Zoom, useMediaQuery } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';

/**
 * 返回顶部按钮组件
 * 滚动超过400px时显示
 */
export default function ScrollToTop() {
  const [show, setShow] = useState(false);
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  };

  return (
    <Zoom in={show}>
      <Fab
        onClick={scrollToTop}
        size="medium"
        aria-label="返回顶部"
        title="返回顶部"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          bgcolor: 'primary.main',
          color: 'white',
          '&:hover': {
            bgcolor: 'primary.dark',
            transform: 'scale(1.1)'
          },
          transition: 'all 0.3s',
          '&:focus': {
            outline: '2px solid',
            outlineColor: 'primary.main',
            outlineOffset: 2
          }
        }}
      >
        <KeyboardArrowUp />
      </Fab>
    </Zoom>
  );
}
